import {useCallback} from 'react';
import {RecaptchaAction} from '../core/settings/settings';
import {useRecaptcha} from '../recaptcha/use-recaptcha';
import {useSmartCaptcha} from './use-smart-captcha';

export function useCaptcha(action: RecaptchaAction) {
  const smart = useSmartCaptcha(action);
  const recaptcha = useRecaptcha(action);

  const verify = useCallback(async () => {
    if (smart.enabled) {
      return smart.verify();
    }
    return recaptcha.verify();
  }, [smart.enabled, smart.verify, recaptcha.verify]);

  return {
    verify,
    isVerifying: smart.enabled ? smart.isVerifying : recaptcha.isVerifying,
    showWidget: smart.enabled,
    widgetRef: smart.containerRef,
  };
}
